// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#messagebox {
  border-radius: 5px;
  width: 100%;
  background-color: #f8f8f8;
  margin-bottom: 7px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  padding-right: 5%;
  font-size: 0.7vw;
  font-weight: 600;
}

#messagebox:hover {
  background-color: #dddddd;
}

.status {
  padding-left: 10px;
  color: var(--theme-main-color, #055C8D);
  width: 100%;
  height: auto;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0.016667px;
}

#messagebox.overdue {
  border-left: solid 4px red;
  cursor: pointer;
}

#messagebox.remaining {
  border-left: solid 4px var(--theme-main-border-color, #055C8D);
  cursor: pointer;
}

.value {
  margin-left: auto;
  font-size: 13px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
